import React, { useEffect, useState, useRef } from "react";
import { useHistory  } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { API } from "aws-amplify";
import { ToastContainer } from "react-toastify";
import moment from "moment";
import {
  alert,
  modalSteps,
  resetRedux,
  stateAlert,
} from "../Store/simulate/actions";
import {
  saveACtiveProductCode
} from "../Store/quote/actions";
import { openModalImproveRate } from "../Store/improveRate/actions";
import { handleState } from "../Utils/utils";

import TitleHeader from "./titleHeader";
import BreadCrumbs from "./BreadCrumbs";
import ModalSide from "./wizard/FormElements/ModalSide";
import Chip from "./wizard/FormElements/Chip";
import { InputsSearchByDNI } from "./wizard/FormElements/InputsSearchByDNI";
import { InputsSearchRV } from "./wizard/FormElements/InputsSearchRV";
import ModalEmision from "./wizard/FormElements/ModalEmision";
import ModalMessage from "../Components/modalMessage";
import ModalConfirm from "../Components/modalConfirm";
import Loading from "../Components/loading";
import ModalImproveRate from "../Components/modalImproveRate";
import SpinnerTable from "../Components/SpinnerTable";
import ModalAttach from "../Components/modalAttach";
import Tabs from "../Components/FormElements/tabs";
import Pagination from "../Components/FormElements/pagination";
import TotalTable from "../Components/FormElements/totalTable";
import ModalFiltering from "../Components/FormElements/ModalFiltering";
import AlertNotifications from "../Components/FormElements/AlertNotifications";
import TableQuotes from "../Components/FormElements/tableQuotes";
import Button from "../Components/FormElements/Button";
import Footer from "../Components/Footer";
import { weftType } from '../Utils/constants';
import IconFilter from "../Resources/svg/Icons/IconFilter";
import IconDelete from "../Resources/svg/Icons/IconDelete";
import GirlImage from "../Resources/svg/human/GirlImage";
import IconBack from "../Resources/svg/Icons/IconBack";
import IconErrorLight from "../Resources/svg/Icons/IconErrorLight";
import IconClose from "../Resources/svg/Icons/IconClose";
import TableQuotesRV from "../Components/FormElements/TableQuotesRV";
import ButtonsSectionRV from "../Components/ButtonsSectionRV";
import IconTableDown from "../Resources/svg/Icons/IconTableDown";
import { downloadXML } from "../Utils/utils";
import { productDictionary } from "../../src/Utils/constants.js";

export default function ListQuotes() {

  const history = useHistory();

  const channel = useSelector((state) => state.login.channel);
  const activeProductCodeFromState = !history.location.state ? 'IG' : useSelector((state) => state.quote.activeProductCode);
  const productosFlagCancelar = useSelector((state) => state.config.productosFlagCancelar || ["IG", "UC"]);

  const availableProducts = useSelector((state) => state.login.access_configuration.availableProducts);
  const capabilities = useSelector((state) => (state.login.access_configuration && state.login.access_configuration.capabilities));

  let listProductsBase = availableProducts.map(product => productDictionary[product]);
  
  if (listProductsBase.some(product => product.code === "RV") && capabilities.canViewRVOfficial === false) {
    listProductsBase = listProductsBase.filter(product => product.code !== "RV");
  }
  const listProducts = [...listProductsBase];

  const [searchInput, setSearchInput] = useState("");
  const [searchType, setSearchType] = useState("documento");
  const [activeState, setActiveState] = useState("todas");
  const [modalData, setModalData] = useState({});

  const foundProduct = listProducts.find(el => el.code == activeProductCodeFromState);
  const [activeProduct, setActiveProduct] = useState(listProducts[0].name);
  const [activeProductCode, setActiveProductCode] = useState(listProducts[0].code);
  const [openModal, setOpenModal] = useState(false);
  const [stateEmision, setStateEmision] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [keyPages, setKeyPages] = useState(null);
  const [tableQuote, setTableQuote] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModalFilterRV, setOpenModalFilterRV] = useState(false);
  const [openModalActionsRV, setOpenModalActionsRV] = useState(false);
  const [openModalMessage, setOpenModalMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [typeMessage, setTypeMessage] = useState("");
  const [itemModalImproveRate, setItemModalImproveRate] = useState(null);
  const [openModalAttach, setOpenModalAttach] = useState(false);
  const [cotiData, setCotiData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [linkPdf, setLinkPdf] = useState("");
  const [openModalConfirmCancel, setOpenModalConfirmCancel] = useState(false);
  const [quoteToCancelData, setQuoteToCancelData] = useState(null);
  const elem = useRef(null);
  const [ handleButtonActionState, handleButtonActionSet ] = useState();
  const [ closingDateState, closingDateSet ] = useState();
  const [ selectedQuotes, setSelectQuotes ] = useState([]);

  const loadingInproveRate = useSelector((state) => state.improveRate.loading);
  const rate = useSelector((state) => state.improveRate.rate);
  const isOpenModalImproveRate = useSelector(
    (state) => state.improveRate.isOpen
  );
  const dispatch = useDispatch();
  const [params, setParams] = useState({
    page: 1,
    limit: 6,
    state: "todas",
    codProd: activeProductCode,
    haveKey: false,
    keyPage: null,
    channel: channel,
  });
  
  const [withParams, setWithParams] = useState(false);

  const [activeOptionButton, setActiveOptionButton] = useState({
    rem: false,
    xmlMeller: false,
    excel: false,
  });

  const timerToClear = useRef(false);
  const limitPage = 6;

  const options = {
    documento: "DNI/CE",
    nombres: "Nombres y apellidos",
  };

  const handleChangeSearch = (event) => {
    const val = event.target.value;
    let validateNumber = /^([0-9])*$/.test(val);

    if (searchType === "documento") {
      if (!validateNumber) {
        return false;
      }
    }
    setSearchInput(val.toUpperCase());
  };

  const handleSearchClick = () => {
    clearTimeout(timerToClear.current);
    timerToClear.current = setTimeout(() => {
      const data = {
        ...params,
        page: 1,
        haveKey: false,
      };
      delete data["filter"];
      if (searchInput !== "") {
        data.filter = {
          key: "documento",
          value: searchInput.toUpperCase(),
        };
      }
      setParams(data);
    }, 1000);
    dispatch(modalSteps(false));
  };

  const handleSearchFilterRVClick = () => {
       clearTimeout(timerToClear.current);
    timerToClear.current = setTimeout(() => {
      const data = {
        ...params,
        page: 1,
        haveKey: false,
      };
      delete data["filter"];
      if (searchInput !== "") {
        data.filter = {
          cuspp: '434343434343',
        };
      }
      setParams(data);
    }, 1000);
    dispatch(modalSteps(false));
  };

  const handleChangeSelect = (event) => {
    const val = event.target.value;
    setSearchInput("");
    setSearchType(val);
  };

  const handleChangeState = (event) => {
    const val = event.target.value;
    setActiveState(val);
    setParams({
      ...params,
      page: 1,
      state: val,
      haveKey: false,
      keyPage: null,
    });
  };

  const handleClickProduct = (val) => {
    setTableQuote([]);
    setActiveProduct(val);
    let code = listProducts.filter((obj) => {
      return obj.name === val;
    })[0].code;
    dispatch(saveACtiveProductCode(code));
    setActiveProductCode(code);
    setParams({
      ...params,
      page: 1,
      codProd: code,
      haveKey: false,
      keyPage: null,
    });
  };

  const setCustomPage = (page) => {
    if (currentPage !== page) {
      setCurrentPage(page);
      setParams({
        ...params,
        page: page,
        haveKey: true,
        keyPage: keyPages[page - 2] || null,
      });
    }
  };

  const handleReset = () => {
    document
      .querySelectorAll('input[type="input"]')
      .forEach((x) => (x.value = ""));
    document
      .querySelectorAll("select")
      .forEach((x) => (x.options.selectedIndex = 0));
    setSearchInput("");
    setSearchType("");
    const data = {
      ...params,
      page: 1,
      haveKey: false,
      keyPage: null,
      state: "todas",
    };
    delete data["filter"];
    data.filter = {
      key: "documento",
      value: "",
    };
    setParams(data);
  };

  const handleResetFilterRV = (valueForm) => {
    const filtered = Object.fromEntries(
      Object.entries(valueForm).filter(([_, value]) => value !== "" && value !== "todas")
    );
    clearTimeout(timerToClear.current);
    timerToClear.current = setTimeout(() => {
      const data = {
        ...params,
        page: 1,
        haveKey: false,
      };

      delete data["filterRV"];
      if (Object.entries(valueForm).length !== 0) {
         data.filterRV = {
          ...filtered
        };
      }
      setParams(data);
    }, 1000);
    dispatch(modalSteps(false));
  };

  const getQuotes = async () => {
    setSelectQuotes([])
    setLoading(true);
    setWithParams(params.filter && params.filter.value);

    if (activeProductCode === "RV") delete params.state;
    localStorage.setItem('REQUEST_RV', JSON.stringify(params));
    const isRV = activeProductCode === "RV";
    const endpoint = isRV ? "/solicitud/listar" : "/cotizaciones";

    const requestBody = isRV ? { payload: {...params, filter: params.filterRV } } : params;
    isRV && delete requestBody.payload['filterRV']
    requestBody.filterRV && delete requestBody['filterRV']
    const response = await API.post(
      `api-${isRV ? "vitalicias" : "rentas"}`,
      endpoint,
      { body: requestBody }
    );

    const { data, last_page, total, keys } = isRV ? response.payload : response;

    setCurrentPage(params.page);
    setTableQuote(data);

    if (keys) {
      setLastPage(last_page);
      setTotalItems(total);
      setKeyPages(keys);
    }

    setLoading(false);
    setIsLoading(false);
  };

  useEffect(() => {
    getQuotes();
  }, [params, rate]);
  const closeModalImproveRate = () => dispatch(openModalImproveRate(false));

  useEffect(() => {
    setTimeout(() => {
      dispatch(stateAlert(false));
    }, 7000);
    dispatch(resetRedux());

    if(!history.location.state){
      dispatch(saveACtiveProductCode('IG'))
    }
  }, []);

  const handleStateClose = () => {
    document
      .querySelectorAll("select")
      .forEach((x) => (x.options.selectedIndex = 0));

    setParams({
      ...params,
      state: "todas",
    });
  };

  const handleAsesorClose = () => {
    document
      .querySelectorAll('input[type="input"]')
      .forEach((x) => (x.value = ""));
    setSearchInput("");
    const data = {
      ...params,
      page: 1,
      haveKey: false,
      keyPage: null,
    };
    delete data["filter"];
    data.filter = {
      key: searchType,
      value: "",
    };
    setParams(data);
  };

  const handleOpenModalAttach = (data) => {
    setOpenModalAttach(true);
    document.body.style.overflow = "hidden";
    setCotiData(data);
  };

  const handleOpenModalFilter = () => {
    if (activeProductCode === "RV") {
      setOpenModalFilterRV(true);
      return;
    }
    setOpenModal(true);
  };

  const reenviarEmail = async (item) => {
    setIsLoading(true);
    dispatch(stateAlert(false));
    try {
      const payloadEmision = {
        body: {
          idSolicitud: item.idCotizacion,
        },
      };

      const response = await API.post(
        "api-rentas",
        "/reenviar-oferta",
        payloadEmision
      );
      if (response.data !== null) {
        setIsLoading(false);

        dispatch(stateAlert(true));
        dispatch(
          alert({
            type: "success",
            title: "¡Link enviado!",
            message: `Se ha enviado correctamente el link biométrico a tu cliente.`,
          })
        );

        setTimeout(() => {
          dispatch(stateAlert(false));
        }, 4000);
      }
    } catch (error) {
      setIsLoading(false);
      dispatch(stateAlert(false));
      console.log(error);
    }
  };

  const handleCancelQuote = (item) => {
    setQuoteToCancelData(item);
    setOpenModalConfirmCancel(true);
  };

 const processCancelQuote = async () => {
  if (!quoteToCancelData) return;
  
  setIsLoading(true);
  dispatch(stateAlert(false));
  
  try {
    const payload = {
      body: {
        cancelarCotizacion: true,
        idCotizacion: quoteToCancelData.idCotizacion
      }
    };

    const response = await API.post(
      "api-rentas",
      "/activacion-manual",
      payload
    );

    if (response.status) {
      const updatedQuotes = tableQuote.map(quote => 
        quote.idCotizacion === quoteToCancelData.idCotizacion 
          ? { ...quote, estado: "cancelada", descripcionEstado: "Cotización cancelada" }
          : quote
      );
      setTableQuote(updatedQuotes);

      dispatch(stateAlert(true));
      dispatch(
        alert({
          type: "success",
          title: "¡Cotización cancelada!",
          message: `La cotización Nº ${quoteToCancelData.numCotizacion} ha sido cancelada correctamente.`,
        })
      );
      
      setQuoteToCancelData(null);
      setOpenModalConfirmCancel(false);
      
      setTimeout(() => {
        dispatch(stateAlert(false));
      }, 4000);
      
      getQuotes();
    } else {
      setIsLoading(false);
      dispatch(stateAlert(true));
      dispatch(
        alert({
          type: "error",
          title: "Error al cancelar",
          message: response.message || "No se pudo cancelar la cotización. Intenta nuevamente.",
        })
      );

      setTimeout(() => {
        dispatch(stateAlert(false));
      }, 4000);
    }
  } catch (error) {
    console.error("Error al cancelar cotización:", error);
    
    setIsLoading(false);
    dispatch(stateAlert(true));
    dispatch(
      alert({
        type: "error",
        title: "Error",
        message: "Ocurrió un error al cancelar la cotización. Intenta nuevamente.",
      })
    );

    setTimeout(() => {
      dispatch(stateAlert(false));
    }, 4000);
  }
};

    const handleDate = (date, type) => {
      if(type == 'CLOSING_DATE'){
        closingDateSet(moment(date).format('YYYY-MM-DD'))
      }
  };

  useEffect(() => {
    if(handleButtonActionState) {
      dowloadFromMeller()
    }
  }, [handleButtonActionState])


    const dowloadFromMeller = async (item) => {
      setIsLoading(true);
      dispatch(stateAlert(false));
      try {
        const payloadMeller = {
          body: {
            payload: {
                fechaCierre: closingDateState,
                estado: "cotizado",
            }
          },
        };

        if(selectedQuotes.length > 0){
          payloadMeller.body.payload.arrayNroOperacion = [...selectedQuotes];
        }else{
          console.log(selectedQuotes, '4')
          delete payloadMeller.body.payload['arrayNroOperacion'];
        }

        const response = await API.post(
          "api-vitalicias",
          "/solicitud/generar/archivo-meller",
          payloadMeller
        );
        if (response.payload ) {
          setSelectQuotes([])
          await Promise.all([
            downloadXML(response.payload.urls.urlGesCot, `GES_COT_${moment().format('DD_MM_YYYY_HH_mm_ss')}`),
            downloadXML(response.payload.urls.urlMeller, `COT_${moment().format('DD_MM_YYYY_HH_mm_ss')}`)
          ]);

          setIsLoading(false);
          dispatch(stateAlert(true));
          dispatch(
            alert({
              type: "success",
              title: "¡Archivo generado!",
              message: `Se ha generado correctamente el archivo desde el meller..`,
            })
          );

          setTimeout(() => {
            dispatch(stateAlert(false));
          }, 4000);
        }
      } catch (error) {
        setIsLoading(false);
        dispatch(stateAlert(false));
        console.log(error);
      }
  };

    useEffect(() => {
    if (linkPdf) {
      elem.current.click();
    }
  }, [linkPdf]);

  return (
    <div>
      <a
        style={{ display: "none" }}
        target="_blank"
        rel="noopener noreferrer"
        href={linkPdf}
        ref={elem}
      />
      <div className="sectionSearch">
        <div className="wrap">
          <div className="content-box">
            <BreadCrumbs rutas={[{ link: "Cotizaciones" }]} />
            <div className="back-responsive">
              <div className="back-responsive__box">
                <IconBack
                  className="nav-case__back"
                  onClick={() => history.push("/productos")}
                />
                <div className="back-responsive__text">Volver</div>
              </div>
            </div>
            <TitleHeader
              title="Listado de cotizaciones"
              titleBold=""
              subtitle="Revisa las cotizaciones que han sido enviadas"
            />
          </div>
        </div>
      </div>

      <div className="sectionTable">
        <div className="wrap">
          <div className="content-box">
            <div className="sectionTable__text">Busca por:</div>
            <div className="sectionTable__options">
              <div className="filter" onClick={() => handleOpenModalFilter()}>
                <IconFilter />
                <div className="filter__text">Filtrar</div>
              </div>
              {activeProductCode === "RV" && (
                <div className="filter">
                  <IconTableDown />
                  <div
                    className="filter__text"
                    onClick={() => setOpenModalActionsRV(true)}
                  >
                    Acciones
                  </div>
                </div>
              )}
            </div>
            <div className="chip-content">
              {params.state !== "todas" && (
                <Chip
                  label={handleState(params.state)}
                  handleCloseChip={handleStateClose}
                  variant="filtro"
                />
              )}
              {searchInput.length > 1 && (
                <Chip
                  label={searchInput}
                  handleCloseChip={handleAsesorClose}
                  variant="asesor"
                />
              )}
            </div>
            {activeProductCode === "RV" ? (
              <>
                <div className="filters-of-rrvv">
                  <InputsSearchRV
                    channel={channel}
                    params={params}
                    setParams={setParams}
                    searchInput={searchInput}
                    codProd={activeProductCode}
                    handleReset={handleResetFilterRV}
                    setActiveOptionButton={setActiveOptionButton}
                    activeOptionButton={activeOptionButton}
                    handleDate={handleDate}
                    onSubmit={handleResetFilterRV}
                  />
                </div>
                <ButtonsSectionRV
                  setIsLoading={setIsLoading}
                  activeButton={activeOptionButton}
                  handleButtonAction={() => dowloadFromMeller()}
                  reloadQuotes={ () => getQuotes()}
                />
              </>
            ) : (
              <div className="list-quote-form-dni">
                <InputsSearchByDNI
                  handleChangeState={handleChangeState}
                  channel={channel}
                  params={params}
                  setParams={setParams}
                  options={options}
                  searchInput={searchInput}
                  handleChangeSearch={handleChangeSearch}
                  handleSearchClick={handleSearchClick}
                  handleChangeSelect={handleChangeSelect}
                  codProd={activeProductCode}
                  handleReset={handleReset}
                />
              </div>
            )}
          </div>

          <Tabs
            disabledTabs={loading}
            values={listProducts.flatMap(({ name }) => name).join()}
            onClick={handleClickProduct}
            activeState={activeProduct}
          />
          <div className="content-box">
            {loadingInproveRate && <Loading />}
            {loading && (
              <>
                <div className="sectionTable__descktop">
                  <div className="skeleton-table">
                    <SpinnerTable
                      title="¡Danos un momento!"
                      subtitle="Se está cargando la información."
                    />
                  </div>
                </div>
                <div className="sectionTable__movile">
                  <SpinnerTable
                    title="¡Danos un momento!"
                    subtitle="Se está cargando la información."
                  />
                </div>
              </>
            )}
            {!loading && tableQuote.length > 0 && (
              <>
                <TotalTable limitPage={limitPage} totalItems={totalItems} />
                <div className="tab-shadow">
                  {activeProductCode === "RV" ? (
                    <TableQuotesRV
                      loading={loading}
                      data={tableQuote}
                      setIsLoading={setIsLoading}
                      getQuotes={getQuotes}
                      closingDateState={closingDateState}
                      selectedQuotes={selectedQuotes}
                      setSelectedQuotes={setSelectQuotes}
                    />
                  ) : (
                    <TableQuotes
                      loading={loading}
                      data={tableQuote}
                      codProd={activeProductCode}
                      setModalData={setModalData}
                      handleOpenModalAttach={handleOpenModalAttach}
                      reenviarEmail={reenviarEmail}
                      handleCancelQuote={handleCancelQuote}
                      productosFlagCancelar={productosFlagCancelar}
                    />
                  )}
                </div>

                <Pagination
                  currentPage={currentPage}
                  lastPage={lastPage}
                  setCurrentPage={setCustomPage}
                />
              </>
            )}
            {!loading && tableQuote.length < 1 && !withParams && (
              <div className="tableMessage">
                <IconErrorLight className="tableMessage__img" />
                <div className="tableMessage__empty">¡Ups! Lo sentimos.</div>
                <div className="tableMessage__message">
                  No encontramos resultados para tu búsqueda. Por favor,
                  verifica que el dato sea correcto.
                </div>
              </div>
            )}
            {!loading && tableQuote.length < 1 && withParams && (
              <div className="tableMessage">
                <GirlImage className="tableMessage__img" />
                <div className="tableMessage__empty">¡Lo sentimos!</div>
                <div className="tableMessage__message">
                  No encontramos resultados para el Nº de documento que
                  ingresaste. <br></br>
                  Revisa que sea el correcto o ingresa uno válido.
                </div>
              </div>
            )}
            <ToastContainer containerId={"A"} />
          </div>
        </div>
      </div>
      <ModalFiltering
        className={`modal-result is-fullscreen  ${openModal ? " is-open" : ""}`}
        open={openModal}
        variant={true}
      >
        <div
          className="modal-filtering__close"
          onClick={() => setOpenModal(false)}
        >
          <IconClose />
        </div>
        <h2 className="modal-result__title">Filtra tu búsqueda</h2>
        <div className="modal-result__desc">
          <InputsSearchByDNI
            handleChangeState={handleChangeState}
            channel={channel}
            params={params}
            setParams={setParams}
            options={options}
            searchInput={searchInput}
            handleChangeSearch={handleChangeSearch}
            handleSearchClick={handleSearchClick}
            handleChangeSelect={handleChangeSelect}
            codProd={activeProductCode}
            handleReset={handleReset}
          />
        </div>
        <div className="actions">
          <div className="actions__clean">
            <IconDelete fill="#A9AFD9" />
            <div className="actions__text" onClick={handleReset}>
              Limpiar
            </div>
          </div>
          <Button
            className="btn actions__btn"
            onClick={handleSearchClick}
            disabled={searchInput === "" ? true : false}
          >
            Buscar
          </Button>
        </div>
      </ModalFiltering>
      {/* modal filter RV */}
      <ModalFiltering
        className={`modal-result is-fullscreen ${
          openModalFilterRV ? " is-open" : ""
        }`}
        open={openModalFilterRV}
        variant={true}
      >
        <div
          className="modal-filtering__close"
          onClick={() => setOpenModalFilterRV(false)}
        >
          <IconClose />
        </div>
        <h2 className="modal-result__title">Filtra tu búsqueda</h2>
        <div className="modal-result__desc">
          <InputsSearchRV
            handleChangeState={handleChangeState}
            channel={channel}
            params={params}
            setParams={setParams}
            options={options}
            searchInput={searchInput}
            handleChangeSearch={handleChangeSearch}
            handleSearchClick={handleSearchFilterRVClick}
            handleChangeSelect={handleChangeSelect}
            codProd={activeProductCode}
            handleReset={handleResetFilterRV}
          />
        </div>
        <div className="actions">
          <div className="actions__clean">
            <IconDelete fill="#A9AFD9" />
            <div className="actions__text" onClick={handleResetFilterRV}>
              Limpiar
            </div>
          </div>
          <Button
            className="btn actions__btn"
            onClick={handleSearchFilterRVClick}
          >
            Buscar
          </Button>
        </div>
      </ModalFiltering>
      {/* modal actions RV */}
      <ModalFiltering
        className={`modal-result is-fullscreen ${
          openModalActionsRV ? " is-open" : ""
        }`}
        open={openModalActionsRV}
        variant={true}
      >
        <div
          className="modal-filtering__close"
          onClick={() => setOpenModalActionsRV(false)}
        >
          <IconClose />
        </div>
        <h2 className="modal-result__title">Acciones disponibles</h2>
        <div className="modal-result__desc">
          <ButtonsSectionRV
            setIsLoading={setIsLoading}
            openModalActionsRV={openModalActionsRV}
            reloadQuotes={ () => getQuotes()}
          />
        </div>
      </ModalFiltering>
      <ModalMessage
        open={openModalMessage}
        setOpen={setOpenModalMessage}
        message={message}
        type={typeMessage}
      />
      <ModalConfirm
        open={openModalConfirmCancel}
        setOpen={setOpenModalConfirmCancel}
        title="Cancelar cotización"
        message={`¿Estás seguro que deseas cancelar la cotización Nº ${quoteToCancelData && quoteToCancelData.numCotizacion ? quoteToCancelData.numCotizacion : ''}?`}
        data={quoteToCancelData}
        acceptCallback={processCancelQuote}
      />
      {/* <ModalConfirm
        open={openModalConfirm}
        setOpen={setOpenModalConfirm}
        title="Activar simulación"
        message={messageConfirm}
        data={dataModalConfirm}
        acceptCallback={processReactiveSimulation}
      /> */}

      <ModalImproveRate
        open={isOpenModalImproveRate}
        close={() => closeModalImproveRate()}
        item={itemModalImproveRate}
      />
      <AlertNotifications />

      <ModalSide
        modalData={modalData}
        ri={false}
        loading={loading}
        title="Detalle de cotización"
        subtitle="Revisa los detalles de la cotización"
        stateTitle={false}
        setStateEmision={setStateEmision}
        weftType={ weftType.quotes }
      />
      <ModalEmision
        isOpen={stateEmision}
        setStateEmision={setStateEmision}
        modalData={modalData}
        getQuotes={getQuotes}
        setParams={setParams}
        setActiveState={setActiveState}
      />
      <ModalAttach
        data={cotiData}
        open={openModalAttach}
        setOpen={setOpenModalAttach}
      />

      <Footer />
      {isLoading && <Loading />}
    </div>
  );
}
